import ModalWrapper from 'components/shared/modal-wrapper';
import { SITE_MAP } from 'globalConstants';
import { ArticleEntity } from 'graphql/blog/queries/article';
import { useModal } from 'hooks';
import Link from 'next/link';
import { ServiceNotarizationPageContext } from 'pages/van-phong-cong-chung';
import { useContext, useState } from 'react';
import ArticleList from './article-list';
import ArticleModal from './article-modal';

const Articles = () => {
  const { pageData } = useContext(ServiceNotarizationPageContext);
  const { articles } = pageData ?? {};
  const { data: articleList } = articles ?? {};
  const [selectedArticle, setSelectedArticle] = useState<ArticleEntity>();
  const { showing: isShowingModal, toggle: toggleModal } = useModal();

  const selectArticle = (article?: ArticleEntity) => {
    setSelectedArticle(article);
    toggleModal();
  };

  return (
    <section
      id='articles'
      className='bg-[url("/images/backgrounds/article-background.webp")] bg-cover bg-fixed bg-center bg-no-repeat py-[40px]'
    >
      <div className='container mx-auto min-w-[1052px] px-[48px]'>
        <ArticleList articleList={articleList} onSelect={selectArticle} />
        <ModalWrapper isClickAway showing={isShowingModal} onToggle={toggleModal}>
          <ArticleModal selectedArticle={selectedArticle} onClose={selectArticle} />
        </ModalWrapper>
        <Link
          target='_blank'
          href={`/${SITE_MAP.NOTARIZATION.INDEX}/${SITE_MAP.NOTARIZATION.NOTARIZATION_DOCUMENT}`}
          className='mt-[53px] flex h-[60px] w-full rounded-full bg-gradient-to-r from-service-primary to-service-secondary duration-[200ms] hover:scale-[1.01]'
        >
          <span className='m-auto text-[24px] font-[600] leading-[29px] text-paper'>
            Đăng ký ngay
          </span>
        </Link>
      </div>
    </section>
  );
};

export default Articles;
